/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import React from "react"
import { SectionGrid, Grid, Flex } from "frontend/src/components/Layout"
import { displayCent, displayPrice } from "frontend/src/utils/displayCent"
import { CMSLink } from "frontend/src/components/CMSLink"
import { SocialProof } from "frontend/src/components/SocialProof"
import { Icon } from "frontend/src/components/Icon"
import { useLocation } from "frontend/src/utils/useLocation"

function OfferLandingpageVariant({ variant, index }) {
  const { pathname } = useLocation()
  const {
    variantTitle,
    variantAvailable,
    variantDescription,
    variantImageURL,
    variantPrice,
    variantComparePrice,
    variantButtonText,
    variantButtonURL,
    showBasicPrice,
    amountPackage,
    basicAmount,
    basicUnit,
    socialProof,
  } = variant
  const buttonDisabled = variantAvailable ? false : true
  const variantOpacity = buttonDisabled ? 0.7 : 1.0
  const grayscaleValue = buttonDisabled ? `grayscale(1)` : `grayscale(0)`
  const buttonText = buttonDisabled
    ? pathname.includes("offer")
      ? "Out sold"
      : "Derzeit ausverkauft"
    : pathname.includes("offer")
    ? "Add to cart"
    : variantButtonText
  const basicPrice = showBasicPrice
    ? Math.round((variantPrice * basicAmount) / amountPackage)
    : null
  const basicPriceText = showBasicPrice
    ? `${displayCent(basicPrice)} / ${basicAmount}${basicUnit}`
    : null
  return (
    <div
      sx={{
        mx: ["auto", "auto", "unset", "unset"],
        width: ["90%", "90%", "95%"],
      }}
    >
      <div
        sx={{
          borderStyle: "solid",
          borderColor: "#000000",
          borderWidth: "0px",
          borderRadius: "20px",
          boxShadow: "5px 10px 30px rgba(0, 0, 0, 0.1)",
          py: 6,
          mb: [5, 5, "unset"],
          opacity: variantOpacity,
          filter: grayscaleValue,
        }}
      >
        <h4
          sx={{
            color: "#008B10",
            fontFamily: "body",
            fontWeight: 700,
            textAlign: "center",
            fontSize: ["4.4584vw", "17.8336px", "1.482418vw", "17.8336px"],
            lineHeight: ["9vw", "36px", "2.9925vw", "36px"],
          }}
        >
          {variantTitle}
        </h4>
        <div
          sx={{
            width: ["73.75vw", "295px", "17.871875vw", "215px"],
            height: ["49.25vw", "197px", "11.97vw", "144px"],
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mx: "auto",
          }}
        >
          <img
            src={variantImageURL}
            alt={variantDescription}
            loading="lazy"
            sx={{ height: "100%", filter: grayscaleValue }}
          />
        </div>
        {variantDescription ? (
          <p
            sx={{
              fontFamily: "body",
              fontWeight: 400,
              fontSize: ["3.4676vw", "13.8704px", "1.152977vw", "13.8704px"],
              lineHeight: ["7vw", "28px", "2.3275vw", "28px"],
              textAlign: "center",
            }}
          >
            {variantDescription}
          </p>
        ) : (
          <div sx={{ height: ["7vw", "28px", "2.3275vw", "28px"] }}>&nbsp;</div>
        )}
        {showBasicPrice && (
          <p
            sx={{
              fontFamily: "body",
              fontWeight: 400,
              fontSize: ["3.4676vw", "13.8704px", "1.152977vw", "13.8704px"],
              lineHeight: ["7vw", "28px", "2.3275vw", "28px"],
              textAlign: "center",
            }}
          >
            {basicPriceText}
          </p>
        )}
        <p
          sx={{
            fontFamily: "body",
            fontSize: ["6.4396vw", "25.7584px", "2.141167vw", "25.7584px"],
            lineHeight: ["7.75vw", "31px", "2.576875vw", "31px"],
            textAlign: "center",
            color: "almostBlack",
            fontWeight: 700,
            my: 3,
          }}
        >
          {displayCent(variantPrice)}
        </p>
        {variantComparePrice ? (
          <p
            sx={{
              fontFamily: "body",
              fontWeight: 400,
              color: "#a3a3a3",
              fontSize: ["4.4584vw", "17.8336px", "1.482418vw", "17.8336px"],
              lineHeight: ["5.5vw", "22px", "1.82875vw", "22px"],
              textAlign: "center",
              mb: 3,
            }}
          >
            statt{" "}
            <span sx={{ textDecoration: "line-through" }}>{displayCent(variantComparePrice)}</span>
          </p>
        ) : (
          <div sx={{ height: ["5.5vw", "22px", "1.82875vw", "22px"], mb: 3 }}>&nbsp;</div>
        )}
        {"showSocialProof" in socialProof && socialProof.showSocialProof && (
          <SocialProof data={socialProof} />
        )}
        <div sx={{ textAlign: "center", mt: 4 }}>
          <CMSLink
            link={{
              event: "addToCart",
              destination: "checkout",
              pageType: "LandingPage",
              price: displayPrice(variantPrice),
              ...variantButtonURL,
            }}
            disabled={buttonDisabled}
            sx={{
              backgroundColor: "almostBlack",
              color: "background",
              fontSize: ["4.9536vw", "19.8144px", "1.647072vw", "19.8144px"],
              fontFamily: "body",
              fontWeight: 700,
              lineHeight: ["9.5vw", "38px", "3.15875vw", "38px"],
              height: ["9.5vw", "38px", "3.15875vw", "38px"],
              width: ["61.75vw", "247px", "20.531875vw", "247px"],
              display: "inline-block",
              borderRadius: "41px",
              cursor: "pointer",
              textAlign: "center",
              border: "none",
              outline: "none",
              "&:active": {
                outline: "none",
              },
            }}
          >
            {buttonText}
          </CMSLink>
          <div
            sx={{
              fontFamily: "body",
              fontWeight: "medium",
              fontSize: 0,
              lineHeight: 1.5,
              height: "1.5em",
              textAlign: "center",
              color: "#007600",
              mt: 5,
            }}
          >
            {variantAvailable ? (
              <React.Fragment>
                <Icon name="Dot" size="1em" color="#007600" />{" "}
                {pathname.includes("offer") ? (
                  <span>In Stock</span>
                ) : (
                  <span>Auf Lager &ndash; in 1-2 Tagen bei Ihnen</span>
                )}
              </React.Fragment>
            ) : (
              <span>&nbsp;</span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

function Benefits({ benefits, checkmarkIcon }) {
  return (
    <Flex
      direction={["column", "column", "row"]}
      justify={["flex-start", "flex-start", "space-around"]}
      sx={{ gridColumn: ["1 / span 1", "1 / span 1", "1 / span 3"], mt: 5 }}
    >
      {benefits.map((benefit, index) => (
        <div
          key={index}
          sx={{
            fontFamily: "body",
            fontWeight: 700,
            lineHeight: ["6.5vw", "26px", "2.16125vw", "26px"],
            fontSize: ["3.9628vw", "15.8512px", "1.317631vw", "15.8512px"],
            width: ["72.5vw", "290px", "24.10625vw", "290px"],
            mx: ["auto", "auto", "unset", "unset"],
            textAlign: "center",
          }}
        >
          <img
            src={checkmarkIcon}
            alt="checkmark"
            sx={{
              width: ["5.5vw", "22px", "1.82875vw", "22px"],
              height: ["5.5vw", "22px", "1.82875vw", "26px"],
              display: "inline-block",
              mr: 1,
              ml: [7, 7, "unset"],
            }}
          />
          <span sx={{ mb: "20px" }}>{benefit}</span>
        </div>
      ))}
    </Flex>
  )
}

function OfferLandingpage({ title, variants, benefits, checkmarkIcon }) {
  return (
    <SectionGrid sx={{ my: "25px" }} id="angebot">
      <SectionGrid.narrow>
        <h3
          sx={{
            textAlign: "center",
            fontFamily: "body",
            fontWeight: 700,
            fontSize: ["5.6964vw", "22.7856px", "1.894053vw", "22.7856px"],
            lineHeight: ["5.75vw", "23px", "1.911875vw", "23px"],
            my: 7,
            mb: 9,
          }}
        >
          {title}
        </h3>
        <Grid columns={["1fr", "1fr", "1fr 1fr 1fr"]} gap={7}>
          {variants &&
            variants.map((variant, index) => (
              <OfferLandingpageVariant key={index} variant={variant} index={index} />
            ))}
        </Grid>
        <Grid columns={["1fr", "1fr", "1fr 1fr 1fr"]} sx={{ pb: 5, pt: [3, 1, 0] }}>
          <Benefits benefits={benefits} checkmarkIcon={checkmarkIcon} />
        </Grid>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { OfferLandingpage }
